import React from "react"
import dayjs from "dayjs"
import { Outlet } from "react-router-dom"

// assets
import primeWhiteLogo from "assets/images/prime-logo-white.png"
import globeLogo from "assets/images/login-globe.png"
import loginBg from "assets/images/login-bg.png"

// utilities
import useAppState from "context/hooks/useAppState"

// styles
import "./authentication-layout.scss"

export default function AuthenticationLayout() {
  const { publicEnvVars } = useAppState()
  return (
    <div className="login-container">
      <img
        className="login-bg-img"
        src={loginBg}
        alt="xogene-prime-bg"
      />

      <div className="login-center-wrap">
        <div className="left-container">
          <div className="main-container">
            <img
              className="prime-logo"
              src={primeWhiteLogo}
              alt="prime-white-logo"
            />
            <img
              className="globe-logo"
              src={globeLogo}
              alt="globe-logo"
            />
            <h1 className="left-caption">
              Stay up to date with global requirements and take control of your compliance.
            </h1>
          </div>
          <div className="footer-container">
            © Copyright {dayjs().format("YYYY")} Xogene Services LLC | V{publicEnvVars.REACT_APP_PRIME_VERSION}
          </div>
        </div>

        <Outlet />
      </div>
    </div>
  )
}
